module.exports = __webpack_public_path__ + "assets/img/Cancel_btn.4d899076.png";